import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  searchedCustomer: null,
  createdCustomer: null, // Store newly created customer info
  selectedAddress: null,
  isUserSearched: false,
  pastOrders: null,
  activeOrders: [], // Add activeOrders to store active order details
  editingAddress: null, // Add state to track which address is being edited
  isEditMode: false, // Track whether we're in edit mode
  service_type: null,
  selectedCompanyAddressId: null, // Track selected company address for corporate catering
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setSearchedCustomer: (state, action) => {
      state.searchedCustomer = action.payload;
      state.isUserSearched = true;
    },
    clearSearchedCustomer: (state) => {
      state.searchedCustomer = null;
      state.isUserSearched = false;
    },
    setCreatedCustomer: (state, action) => {
      state.createdCustomer = action.payload;
    },
    setPastOrders: (state, action) => {
      state.pastOrders = action.payload;
    },
    setActiveOrders: (state, action) => {
      // Filter and store only the required fields for active orders
      state.activeOrders = action.payload.filter(order => 
        ["Ready for Dispatch", "Preparing", "On the way", "Submitted", "Accepted", "Delivered"]
        .includes(order.order_status)
      ).map(order => ({
        address_id: order.address_id,
        restaurant_id: order.restaurant_id,
        service_type: order.service_type,
        branch_id: order.branch_id
      }));
    },

    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload;
    },
    setServiceType: (state, action) => {
      state.service_type = action.payload;
    },
    setIsUserSearched: (state, action) => {
      state.isUserSearched = action.payload;
    },
    setEditingAddress: (state, action) => {
      state.editingAddress = action.payload;
      state.isEditMode = action.payload !== null;
    },
    setSelectedCompanyAddressId: (state, action) => {
      state.selectedCompanyAddressId = action.payload;
    },
  },
});

export const {
  setSearchedCustomer,
  clearSearchedCustomer,
  setCreatedCustomer,
  setPastOrders,
  setActiveOrders,
  setSelectedAddress,
  setServiceType,
  setIsUserSearched,
  setEditingAddress,
  setSelectedCompanyAddressId,
} = customerSlice.actions;
export default customerSlice.reducer;
